import { ToastModalContent } from './ToastModalContent';

export default {
  ReactComponent: ToastModalContent,
  bindings: {
    importShiftSchedulesCallback: '<',
    onClose: '<',
    trackAnalyticsEvent: '<',
    currentUser: '<',
  },
};
